import React from 'react'

import { ToolTip } from '@octane/spark'
import { formatPhoneNumber } from 'utils/formatPhoneNumber'

import { MainText, PhoneNumber, Wrapper } from './CustomerAgent.styled'

interface CustomerAgentProps {
    agentName?: string
    phoneNumber?: string
    extension?: string
    whiteLabelId?: string
}

export default function CustomerAgent({
    agentName,
    phoneNumber,
    extension,
    whiteLabelId,
}: Readonly<CustomerAgentProps>): JSX.Element {
    const goodSamStyling = whiteLabelId === 'goodSam'

    if (!agentName || !phoneNumber) {
        const defaultText = 'Call us! Credit Ops'
        const defaultPhoneNumber = '6463705471'

        return (
            <Wrapper data-testid="customer-agent">
                <MainText goodSamStyling={goodSamStyling}>
                    {defaultText}
                </MainText>
                <PhoneNumber goodSamStyling={goodSamStyling}>
                    {formatPhoneNumber(defaultPhoneNumber)}
                </PhoneNumber>
            </Wrapper>
        )
    }

    const agentText = `Call us! Your rep is ${agentName}`
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber)
    const extensionText = extension && `ext. ${extension}`

    return (
        <ToolTip
            showOnHover
            size="small"
            placement="bottom"
            text={`${agentText} ${formattedPhoneNumber} ${extensionText}`}
            trigger={
                <Wrapper data-testid="customer-agent">
                    <MainText goodSamStyling={goodSamStyling}>
                        {agentText}
                    </MainText>
                    <PhoneNumber goodSamStyling={goodSamStyling}>
                        {formattedPhoneNumber} {extensionText}
                    </PhoneNumber>
                </Wrapper>
            }
        >
            {' '}
        </ToolTip>
    )
}
